import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const TmTheme = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#EDF8F4',
      100: '#E6FBF3',
      200: '#B3F4D9',
      300: '#B3F4D9',
      400: '#33E594',
      500: '#09DE74',
      600: '#07C965',
      700: '#05A653',
      800: '#048444',
      900: '#026336',
      950: '#014527',
    },
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: '#024653',
              hoverBackground: '#052f36',
              activeBackground: '#04282e',
              borderColor: '#024653',
              hoverBorderColor: '#052f36',
              color: '#ffffff',
            },
          },
          text: {
            primary: {
              color: '#024653',
            },
          },
        },
      },
    },
    stepper: {
      colorScheme: {
        light: {
          step: {
            number: {
              active: {
                borderColor: '#024653',
                color: '#024653',
              },
            },
            title: {
              active: {
                color: '#024653',
              },
            },
          },
        },
      },
    },
  },
});

export { MOBILE_FAB_BUTTON_TOKENS } from './tm-theme-mobile.tokens';

export default TmTheme;
